import React, { Component } from 'react'
import { Link } from 'react-router'
import { Row, Col, FormGroup, FormControl, ControlLabel } from 'react-bootstrap'
import i18next from 'i18next'
import moment from 'moment'
import DatePicker from './DatePicker'
import Button from './Button'
import Notificator from './Notificator'
import TagAutocomplete from './TagAutocomplete'

import invitationStyles from './styles/invitation.scss'
import { availableLanguagesWopi360 } from './../assets/translations/availableLanguages'
import { isMandatory } from './styles/questionnaire.scss'

export default class Wopi360TargetForm extends Component {
  constructor(props) {
    super(props)

    const { target } = props

    this.state = {
      givenName: target ? target.givenName : '',
      familyName: target ? target.familyName : '',
      email: target ? target.email : '',
      emailDisclaimer: false,
      organisation: target ? target.organisation : '',
      role: target ? target.role : '',
      isManager: target ? target.isManager : false,
      language: target ? target.language : 'fi',
      canInvite: target ? target.canInvite : false,
      deadlineAt: target ? moment(target.deadlineAt) : moment().add(2, 'weeks'),
      message: '',
      units: target ? target.units : [],

      form: {
        isValid: target,
        invalidEmails: []
      }
    }
  }

  render() {
    const { currentLanguage, saveText, cancelTo, target, unitSuggestions, hideUnits } = this.props

    return (
      <div>
        <div className={invitationStyles.wopi360TargetForm}>
          <Row>
            <Col md={4} sm={12}>
              <h2>{i18next.t('target_person_information')}</h2>

              <FormGroup controlId="givenName">
                <ControlLabel>
                  <span>{i18next.t('given_name')}</span>
                  <span className={isMandatory}>*</span>
                </ControlLabel>

                <FormControl
                  name="givenName"
                  type="text"
                  onChange={this.handleChange}
                  value={this.state.givenName}
                  required
                  aria-required="true"
                />
              </FormGroup>

              <FormGroup controlId="familyName">
                <ControlLabel>
                  <span>{i18next.t('family_name')}</span>
                  <span className={isMandatory}>*</span>
                </ControlLabel>

                <FormControl
                  name="familyName"
                  type="text"
                  onChange={this.handleChange}
                  value={this.state.familyName}
                  required
                  aria-required="true"
                />
              </FormGroup>

              <FormGroup controlId="email">
                <ControlLabel>
                  <span>{i18next.t('email')}</span>
                  <span className={isMandatory}>*</span>
                </ControlLabel>

                <FormControl
                  name="email"
                  type="email"
                  onChange={this.handleChange}
                  value={this.state.email}
                  required
                  aria-required="true"
                />
              </FormGroup>

              <FormGroup controlId="organisation">
                <ControlLabel>{i18next.t('organisation')}</ControlLabel>

                <FormControl
                  name="organisation"
                  type="text"
                  onChange={this.handleChange}
                  value={this.state.organisation}
                />
              </FormGroup>

              {!hideUnits && (
                <FormGroup controlId="units">
                  <ControlLabel>{i18next.t('units')}</ControlLabel>

                  <TagAutocomplete
                    tags={this.state.units}
                    suggestions={unitSuggestions}
                    onAdd={this.handleUnitAdd}
                    onDelete={this.handleUnitRemove}
                  />
                </FormGroup>
              )}

              <FormGroup controlId="role">
                <ControlLabel>{i18next.t('role')}</ControlLabel>

                <FormControl
                  name="role"
                  type="text"
                  onChange={this.handleChange}
                  value={this.state.role}
                />
              </FormGroup>

              <FormGroup controlId="isManager">
                <ControlLabel>
                  <span>{i18next.t('manager_position')}</span>
                  <span className={isMandatory}>*</span>
                </ControlLabel>

                <FormControl
                  name="isManager"
                  componentClass="select"
                  onChange={this.handleIsManagerChange}
                  defaultValue={this.state.isManager.toString()}
                  disabled={Boolean(target)}
                >
                  <option value="false">{i18next.t('no')}</option>
                  <option value="true">{i18next.t('yes')}</option>
                </FormControl>
              </FormGroup>

              <FormGroup controlId="language">
                <ControlLabel>{i18next.t('language')}</ControlLabel>

                <FormControl
                  name="language"
                  componentClass="select"
                  onChange={this.handleChange}
                  defaultValue={this.state.language}
                >
                  {availableLanguagesWopi360.map((l, key) => (
                    <option value={l.key} key={key}>
                      {i18next.t(l.translationKey)}
                    </option>
                  ))}
                </FormControl>
              </FormGroup>

              {!target && (
                <FormGroup controlId="message">
                  <ControlLabel>{i18next.t('invitation_message')}</ControlLabel>

                  <FormControl
                    name="message"
                    componentClass="textarea"
                    rows="6"
                    onChange={this.handleChange}
                    value={this.state.message}
                  />
                </FormGroup>
              )}

              <FormGroup controlId="emailDisclaimer" style={{ paddingTop: '20px' }}>
                <input
                  type="checkbox"
                  name="emailDisclaimer"
                  onChange={this.onChangeToggleChecked.bind(this)}
                  defaultChecked={this.state.emailDisclaimer}
                />
                <span style={{ paddingLeft: '10px' }}>
                  {i18next.t('email_disclaimer_checkbox_label')}
                </span>
              </FormGroup>
            </Col>

            <Col md={8} sm={12}>
              <h2>{i18next.t('test_deadline')}</h2>

              <p>
                <strong>{i18next.t('last_day_to_answer')}</strong>
              </p>

              <DatePicker
                date={this.state.deadlineAt}
                onDateChange={this.handleDeadlineChange}
                language={currentLanguage}
                numberOfMonths={2}
              />

              <Notificator type="info">
                <p>{i18next.t('notification_profile_deletion_description')}</p>
                <br />

                <p>{i18next.t('notification_profile_as_administrator_description')}</p>
              </Notificator>
            </Col>
          </Row>
        </div>

        <div style={{ margin: '20px 0' }}>
          <Button text={saveText} onClick={this.handleSave} disabled={!this.state.form.isValid} />

          <span style={{ marginLeft: 5 }}>
            {i18next.t('or')} <Link to={cancelTo}>{i18next.t('cancel')}</Link>
          </span>
        </div>
      </div>
    )
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value }, this.validateState)
  }

  onChangeToggleChecked(e) {
    this.setState({ [e.target.name]: e.target.checked }, this.validateState)
  }

  handleIsManagerChange = e => {
    if (e.target.value === 'true') {
      this.setState({ isManager: true })
    } else {
      this.setState({ isManager: false })
    }
  }

  handleDeadlineChange = date => {
    this.setState({
      deadlineAt: date
    })
  }

  handleUnitAdd = unit => {
    this.setState(state => ({
      units: state.units.some(stateUnit => stateUnit.uuid === unit.uuid)
        ? state.units
        : [...state.units, unit]
    }))
  }

  handleUnitRemove = index => {
    this.setState(state => ({ units: state.units.filter((_, i) => i !== index) }))
  }

  validateState() {
    const validate = () => {
      return {
        isValid:
          this.state.givenName.trim() !== '' &&
          this.state.familyName.trim() !== '' &&
          this.state.email.trim() !== '' &&
          this.state.language !== '' &&
          this.state.emailDisclaimer &&
          moment.isMoment(this.state.deadlineAt)
      }
    }

    this.setState({ form: validate() })
  }

  handleSave = () => {
    this.props.onSave(
      this.state.givenName,
      this.state.familyName,
      this.state.email,
      this.state.organisation,
      this.state.role,
      this.state.deadlineAt,
      this.state.language,
      this.state.units.map(unit => unit.uuid),
      this.state.isManager,
      this.state.canInvite,
      this.state.message
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Wopi360TargetForm.js